import { MinusCircleFilled, MinusCircleOutlined, PlusCircleFilled, PlusOutlined } from '@ant-design/icons';
import { Form, Input, Select, Row, Col, Button, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import ImageSniper from './ImageSniper';

const ImageSniperAddNew = ({
    label,
    height,
    labelCol,
    name,
    form,
    placeholder,
    defaultValue,
    disabled,
    hideLabel,
    required,
    data,
    errorMessage
}) => {
    const [rowLength, setRowLength] = useState('1');

    useEffect(() => {
        if(data[name]?.count){
            setRowLength(data[name].count)
        }
    }, []);


    useEffect(() => {
        form.setFieldsValue({ [`${name}-count`]: rowLength })
    }, [rowLength]);

    // useEffect(() => {
    //     if (defaultValue) {
    //         form.setFieldsValue({ [name]: defaultValue });
    //     }
    // }, []);

    // const onRowRemove = (currentRow) => {
    //     let formValues = form.getFieldsValue();
    //     for (var i = currentRow; i < rowLength; i++) {
    //         form.setFieldsValue({ [`${name}-${i}`]: formValues[`${name}-${i + 1}`] })
    //     };
    //     form.setFieldsValue({ [`${name}-${rowLength}`]: null })
    //     setRowLength(rowLength - 1);
    // }

    const deleteRow = (index) => {
        form.setFieldsValue({ [`${name}-${index + 1}`]: null });
        setRowLength(rowLength - 1);
    };

    const returnData = (index) => {
        let __Data = {...data};
        if(data[name]?.data?.[index]){
            __Data.params._id = data[name]?.data[index];
            __Data.hasImage = true;
            return __Data
        } else {
            __Data.hasImage = false;
            return __Data;
        }
    }

    return (
        <div style={{ display: 'inline-flex', flexWrap: 'wrap', justifyContent: (parseInt(rowLength) % 3) === 0 ? 'space-between' : '', width: '100%' }}>
            <>
                <Form.Item
                    name={`${name}-count`}
                    hidden={true}
                />
                {
                    Array.from({ length: parseInt(rowLength) }).map((_, i) => (
                        <div className='img-sniper-add' style={{ marginRight: (parseInt(rowLength) % 3) === 0 ? 0 : 25 }}>
                            <div style={{ width: '90%' }}>
                                <ImageSniper
                                    hideLabel={hideLabel}
                                    placeholder={placeholder ? placeholder + "-" + i : 'Paste your image - ' + i}
                                    labelCol={labelCol} height={height}
                                    name={name + "-" + i}
                                    label={label + "-" + i}
                                    data={returnData(i)}
                                    form={form}
                                    required={i === 0 ? required : true}
                                    disabled={disabled}
                                />
                            </div>
                            <div style={{ width: '5%', marginTop: 20, display: 'inline-block' }}>
                                {/* {
                                    (i + 1) === parseInt(rowLength) ?
                                        <Tooltip title="Add New" color="geekblue">
                                            <Button
                                                icon={<PlusCircleFilled />}
                                                disabled={disabled} type="link" onClick={() => setRowLength(parseInt(rowLength) + 1)}>{''}</Button>

                                        </Tooltip>
                                        :
                                        <Tooltip title="Delete" color="geekblue">
                                            <Button
                                                icon={<MinusCircleFilled />}
                                                disabled={disabled} type="link" onClick={() => onRowRemove(i + 1)}>{''}</Button>
                                        </Tooltip>

                                } */}
                                {
                                    (i + 1) === parseInt(rowLength) ?
                                        <>
                                            <Tooltip title="Add New" color="green">
                                                <Button
                                                    className='add-new-icon'
                                                    icon={<PlusCircleFilled />}
                                                    disabled={disabled} type="link" onClick={() => setRowLength(parseInt(rowLength) + 1)}>{''}</Button>

                                            </Tooltip>
                                            {
                                                rowLength > 1 && (
                                                    <Tooltip title="Delete" color="red">
                                                        <Button
                                                            className='delete-row-icon'
                                                            icon={<MinusCircleFilled />}
                                                            disabled={disabled} type="link" onClick={() => deleteRow(i)}>{''}</Button>
                                                    </Tooltip>
                                                )
                                            }

                                        </> : <></>

                                }
                            </div>
                        </div>
                    ))
                }
            </>
        </div>
    )
};


export default ImageSniperAddNew;